export const subscriberConstants = {
    EMAIL_LIST_SUCCESS: "EMAIL_LIST_SUCCESS",
    SUBSCRIBER_LIST_SUCCESS: "SUBSCRIBER_LIST_SUCCESS",
};